<template>
  <b-modal id="userSearchModal" ref="userSearchModal" no-close-on-esc @hidden="resetModal" @close="resetModal">
    <template slot="modal-title"> {{ $t('userSearch') }}
      <font-awesome-icon id="userSearchTip" icon="info-circle"/>
      <b-tooltip target="userSearchTip">{{ $t('toolTip.userSearchTip')}}</b-tooltip>
    </template>

    <b-form-group id="user-search-group">
      <b-form-input size="sm" id="user" type="text" v-model.trim="username" :state="userState" v-on:keyup="onKeyup" :placeholder="$t('typeUserNameOrIdAndHitEnter')" />
      <p/>
      <strong v-if="userSearchCounts === 0 && !userId && hasSearched" class="text-info"> {{ $t('noResults')}}</strong>
      <b-form-invalid-feedback id="user-feedback" v-if="username">
        {{ $t('requireThreeLetters')}}
      </b-form-invalid-feedback>
      <div class="aco-dropdown-item" v-for="user in users" :key="user.userId" @click="selectUser(user)">
        {{ user.fullName }} ({{ user.username }})
      </div>
    </b-form-group>

    <b-form-group v-if="fullName" id="fullName-group" :label="$t('fullName')" label-for="fullName">
      <b-form-input size="sm" id="fullName" type="text" v-model="fullName" readonly/>
    </b-form-group>

    <b-form-group v-if="email" id="email-group" :label="$t('email')" label-for="email">
      <b-form-input size="sm" id="email" type="text" v-model="email" readonly/>
    </b-form-group>

    <b-form-group v-if="userId" id="userId-group" :label="$t('userId')" label-for="userId">
      <b-form-input size="sm" id="userId" type="text" v-model="userId" readonly/>
    </b-form-group>

    <div slot="modal-footer" class="col-md-12">
      <b-button variant="primary" class="float-lg-right" v-on:click="selectedOwnerUser" :disabled=validate>{{ $t('use') }}</b-button>
      <b-button variant="secondary" class="float-lg-left" v-on:click="resetModal">{{ $t('cancel') }}</b-button>
    </div>

  </b-modal>

</template>
<script>

  import UserService from '../services/UserService'

  export default {
    name: 'UserSearch',
    data () {
      return {
        username : '',
        users: [],
        fullName: '',
        userId: '',
        email: '',
        isButtonDisabled: true,
        user: {},
        hasSearched: false,
      }
    } ,

    computed : {
      userState () {
        let username = this.username
        return username && username.length >= 3
      },
      userSearchCounts () {
        return this.users && this.users.length
      },
      validate () {
        return (this.fullName && this.userId && this.isButtonDisabled === true)
      }
    } ,
    methods: {
      onKeyup (event) {
        if(event.which === 13){
          if(!this.userState){
            return
          }
          this.searchUser()
        }
      },
      searchUser () {
        UserService.searchUser(this.username)
          .then((response) => this.users = response.response)
          .finally(() => this.hasSearched = true)
      },
      selectUser (user) {
        this.fullName = user.fullName
        this.userId = user.userId
        this.email = user.email
        this.user = user
        this.username = ''
        this.users = []
        this.isButtonDisabled = false
      },
      selectedOwnerUser () {
        this.$emit('selectedOwnerUser', this.user)
        this.resetModal()
      },
      showModal () {
        this.$bvModal.show('userSearchModal')
      },
      resetModal () {
        this.fullName = ''
        this.userId = ''
        this.email = ''
        this.username = ''
        this.users = []
        this.isButtonDisabled = true
        this.$refs['userSearchModal'].hide()
      }
    }
  }

</script>
